import { NavbarBorrowSystem } from "../../components/share/NavbarBorrowSystem";
import { HeadTitle } from "../../components/share/HeadTitle";
import { BorrowFollowSixComponent } from "../../components/borrowSystem/BorrowFollowSixComponent";
import { Footer } from "../../components/share/Footer";

export function BorrowFollowSixContainer() {
  const titleName =
    "แบบติดตามประเมินผลการให้กู้ยืมเงินกองทุนพัฒนาฝีมือแรงงานกรมพัฒนาฝีมือแรงงาน กระทรวงแรงงาน กย.6";
  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <BorrowFollowSixComponent />
      <Footer />
    </div>
  );
}
